/**
 * Carimbo de tempo dos arquivos do STAR: `YYYYDDDHHMM` (ano, dia juliano, hora e
 * minuto em UTC). Ex.: "20262580020" = 15/09/2026 00:20 UTC.
 */

const pad = (n: number, len = 2) => String(n).padStart(len, '0');

function isLeapYear(y: number): boolean {
  return (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
}

/** Dia juliano (1–366) de um instante UTC. */
export function dayOfYear(ms: number): number {
  const d = new Date(ms);
  const start = Date.UTC(d.getUTCFullYear(), 0, 1);
  return Math.floor((ms - start) / 86_400_000) + 1;
}

/** "20262580020" → epoch ms (UTC), ou null se inválido. */
export function parseStarStamp(stamp: string): number | null {
  if (!/^\d{11}$/.test(stamp)) return null;
  const year = Number(stamp.slice(0, 4));
  const doy = Number(stamp.slice(4, 7));
  const hour = Number(stamp.slice(7, 9));
  const minute = Number(stamp.slice(9, 11));
  if (doy < 1 || doy > (isLeapYear(year) ? 366 : 365) || hour > 23 || minute > 59) return null;
  // Date.UTC normaliza "dia 258 de janeiro" para a data correta.
  return Date.UTC(year, 0, doy, hour, minute);
}

/** epoch ms (UTC) → "YYYYDDDHHMM". */
export function formatStarStamp(ms: number): string {
  const d = new Date(ms);
  return `${d.getUTCFullYear()}${pad(dayOfYear(ms), 3)}${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}`;
}
